import DiskBackupSection from "./diskBackupSection";

const VmBackupCard = ({ vmData }) => {
    const vaultName = vmData.disks?.[0]?.vaultName || "No vault";
    
    return (
        <div className="bg-primary-dark rounded-2xl overflow-hidden shadow-lg border border-gray-700 px-2">
            <div className="bg-primary-dark/80 px-6 py-4 border-b border-gray-700">
                <div className="flex justify-between items-center">
                    <h2 className="text-2xl font-bold text-white">VM Name : {vmData.vmName}</h2>
                    <span className="text-primary-cyan font-medium bg-primary-cyan/10 px-4 py-1 rounded-full text-sm">
                        Vault Name : {vaultName}
                    </span>
                </div>
            </div>
            
            <div className="p-6 space-y-5">
                {vmData.disks?.map((disk, index) => (
                    <DiskBackupSection key={index} diskData={disk} />
                ))}
            </div>
        </div>
    );
};

export default VmBackupCard;